<template>
  <div id="app">
    <!-- TopBar for logged-in users -->
    <TopBar v-if="isLoggedIn" @toggle-sidebar="toggleSidebar" />
    
    <!-- SideBar for logged-in users -->
    <SideBar v-if="isLoggedIn" :is-mobile-open="isSidebarOpen" @close-sidebar="closeSidebar" />
    
    <!-- Main content area -->
    <div class="main" :class="{
      'container': isLoggedIn, 
      'auth-page': !isLoggedIn,
      'with-sidebar': isLoggedIn
    }">
      <router-view/>
    </div>
    
    <!-- Mobile sidebar overlay -->
    <div 
      v-if="isLoggedIn && isSidebarOpen" 
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>
  </div>
</template>

<script>
// @ is an alias to /src
import TopBar from '@/components/TopBar.vue'
import SideBar from '@/components/SideBar.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    TopBar,
    SideBar
  },
  data() {
    return {
      isSidebarOpen: false
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    isLoggedIn() {
      return this.isAuthenticated
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    closeSidebar() {
      this.isSidebarOpen = false
    }
  },
  mounted() {
    // Close sidebar when clicking outside on mobile
    document.addEventListener('click', (e) => {
      if (window.innerWidth <= 768 && this.isSidebarOpen) {
        const sidebar = document.querySelector('.sidebar')
        const topbar = document.querySelector('.topbar')
        if (sidebar && !sidebar.contains(e.target) && topbar && !topbar.contains(e.target)) {
          this.closeSidebar()
        }
      }
    })

    // Bootstrap data after authentication
    if (this.isLoggedIn) {
      this.$store.dispatch('fetchLimits');
      this.$store.dispatch('fetchPlans');
      this.$store.dispatch('fetchUserSubscriptions');
      this.$store.dispatch('loadTheme');
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main {
  padding-top: 1em;
  transition: margin-left 0.3s ease;
}

.main.container {
  padding-top: 5em;
}

.main.with-sidebar {
  margin-left: 280px;
  padding-top: 80px; /* Account for TopBar height */
}

.auth-page {
  padding: 0;
  min-height: 100vh;
  width: 100%;
  background-color: #f8f9fa;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

#nprogress .bar {
  background: #3498db;
  height: 3px;
}

#nprogress .peg {
  box-shadow: 0 0 10px #3498db, 0 0 5px #3498db;
}

#nprogress .spinner-icon {
  display: none;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .main.with-sidebar {
    margin-left: 0;
    padding-top: 80px; /* Only account for TopBar on mobile */
  }
  
  .sidebar-overlay {
    display: block;
  }
}
</style>

